// 表示（一回のみ）管理
import commonClass from "./commonClass";

export default class showOnceClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._parentSelector = '.js-showonce_prt';
    this._triggerSelector = '.js-showonce_trg';
    this._targetSelector = '.js-showonce_tgt';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    $(document).on('click', cls._triggerSelector, function() {
      var $this = $(this);

      if ($this.text() == '編集する') {
        $this.text('閉じる');
      } else {
        $this.text('編集する');
      }
          
      //$this.closest(cls._parentSelector).find(cls._targetSelector).fadeIn(); // 2020.12.15 田村修正
      $this.closest(cls._parentSelector).find(cls._targetSelector).fadeToggle();

      // if ($this.hasClass('is-afterhide')) {
      //   $this.hide();
      // }

      return false;
    });
  }

}